import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about-section">
      <div className="content-wrapper">
        <div className="about-header">
          <span className="pre-title">Your AI-Powered Tax & Financial Advisor</span>
          <h1>Welcome to <span className="highlight">ProfiTree</span></h1>
          <p className="lead">
            We combine cutting-edge AI with <span className="highlight-keyword">advanced tax strategies</span> to help you maximize 
            your wealth through intelligent tax optimization. Experience the future of 
            <span className="highlight-keyword">tax-smart</span> financial planning, today.
          </p>
        </div>

        <div className="about-content">
          <div className="vision-section">
            <div className="vision-card">
              <div className="card-content">
                <h2>Our Vision</h2>
        <p>
                  We envision a world where <span className="highlight-keyword">sophisticated tax optimization</span> strategies aren't 
                  just for Wall Street experts. By combining AI technology with advanced 
                  tax intelligence, we're <span className="highlight-keyword">democratizing</span> access to professional-grade 
                  tax and financial advisory tools.
                </p>
              </div>
              <div className="stats-grid">
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <span className="stat-label">Tax Monitoring</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">AI</span>
                  <span className="stat-label">Tax Intelligence</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">Tax</span>
                  <span className="stat-label">Optimization</span>
                </div>
              </div>
            </div>
          </div>

          <div className="backstory-section">
            <h2>Our Story</h2>
            <div className="story-content">
              <p>
                Our founder discovered he had overpaid <span className="highlight-keyword">$15,000 in taxes</span> due to a lack of tax 
                optimization strategies. This realization highlighted the gap between investment 
                knowledge and <span className="highlight-keyword">tax efficiency</span>, driving the development of automated tax optimization tools.
              </p>
              <p>
                What began as a <span className="highlight-keyword">personal solution</span> to track <span className="highlight-keyword">tax-loss harvesting</span> and <span className="highlight-keyword">wash sales</span> 
                avoidance quickly evolved into a comprehensive platform. As we refined the technology, 
                we recognized that millions of investors face similar challenges in optimizing 
                their tax positions without access to professional-grade tools.
              </p>
              <p>
                ProfiTree emerged from this need - transforming complex tax strategies into 
                accessible, AI-powered solutions. Today, we provide investors with the same 
                tax optimization capabilities used by institutional wealth managers, ensuring 
                <span className="highlight-keyword">maximum after-tax returns</span> for every portfolio.
              </p>
            </div>
          </div>

          <div className="team-section">
            <h2>Our Team</h2>
            <div className="team-content">
              <p>
                ProfiTree was founded by a team with deep expertise in <span className="highlight-keyword">technology, finance, and tax strategy</span>. 
                Our founders bring extensive experience from leading wealth management firms like <span className="highlight-keyword">Schwab</span>, 
                growth-stage venture capital, and include a <span className="highlight-keyword">tech-driven founder</span> who has worked at <span className="highlight-keyword">Amazon, Accenture</span>, 
                and early-stage startups. This unique combination of wealth management expertise 
                and technical innovation gives us a real-world understanding of tax optimization challenges 
                faced by investors at every level.
              </p>
              <p>
                Our team brings together exceptional talent from technology, finance, and legal 
                domains. With deep experience in product development, design, and operations 
                from leading startups and enterprises, we combine diverse expertise to build 
                something truly revolutionary in tax optimization.
              </p>
              <p>
                What unites us is our <span className="highlight-keyword">passion for democratizing sophisticated tax optimization 
                strategies</span> and our belief that every investor deserves access to professional-grade 
                tax advisory tools. We're committed to <span className="highlight-keyword">empowering DIY investors</span> with the technology and 
                insights they need to maximize their wealth through intelligent tax strategies.
              </p>
            </div>
          </div>
        </div>

        <div className="about-footer">
          <div className="cta-section">
            <h2>Ready to Get Started?</h2>
        <p>
              Join thousands of investors who are already benefiting from our 
              AI-powered tax optimization strategies.
        </p>
            <div className="cta-buttons">
              <a href="/signup" className="primary-button">Start Tax-Smart Planning</a>
              <a href="mailto:support@profitree-tax.com" className="secondary-button">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;





